"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsPure = void 0;
const React = __importStar(require("react"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const tab_1 = __importDefault(require("./tab"));
const tabs_pure_1 = __importDefault(require("./tabs-pure"));
require("nav-frontend-tabs-style");
class Tabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            aktivTab: props.defaultAktiv,
        };
    }
    setActiveTab(e, index) {
        this.setState({ aktivTab: index }, () => {
            this.pure.linkRefs[index].focus();
        });
        this.props.onChange(e, index);
    }
    renderTabs() {
        if (this.props.children) {
            return React.Children.map(this.props.children, (child, i) => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, {
                        aktiv: i === this.state.aktivTab,
                    });
                }
                return child;
            });
        }
        if (this.props.tabs) {
            return this.props.tabs.map((tab, i) => (React.createElement(tab_1.default, Object.assign({ key: (0, nav_frontend_js_utils_1.guid)(), aktiv: i === this.state.aktivTab }, tab))));
        }
        return null;
    }
    render() {
        const domProps = (0, nav_frontend_js_utils_1.omit)(this.props, "tabs", "onChange", "defaultAktiv", "ref");
        return (React.createElement(tabs_pure_1.default, Object.assign({ ref: (pure) => (this.pure = pure), onChange: (e, index) => this.setActiveTab(e, index) }, domProps), this.renderTabs()));
    }
}
Tabs.Tab = tab_1.default;
Tabs.defaultProps = {
    kompakt: false,
    defaultAktiv: 0,
};
exports.default = Tabs;
var tabs_pure_2 = require("./tabs-pure");
Object.defineProperty(exports, "TabsPure", { enumerable: true, get: function () { return __importDefault(tabs_pure_2).default; } });
